<template>  
    <section :class='isShowStatus?"":"no-p"'>
		<!-- 订单超时提醒 -->
		<common-modal v-if="isOverTime">
		    <div class="time-wrap">
				<div class="over-time" >
					<div class="tips">提示</div>
					<div class="left-time">{{leftTime}}</div>
					<div class="know" @click="onCloseModalClick">我知道了</div>
				</div>
			</div>
		</common-modal>		
		
		<!-- 是否设置截止时间弹框 -->
		<common-modal :showClose="true" v-if="isShowTime"  @close-modal="onCloseModalClick">
		    <div class="modal">
		        <div class="title">是否设置截止时间</div>
		        <div class="time-common set-time" @click="showDatePicker">设置截止时间</div>
		        <div class="time-common no-time"  @click="noSetHandle">无需设置</div>
		    </div>
		</common-modal>
		
		<!-- 设置截止时间成功 -->
		<confirm-modal v-if="isSetTime" :noWidth="true" :isEnough="true" :firmTitle="firmTitle" :firmLeft="firmLeft" :firmRight="firmRight"
		    @leftClick="goBackList" @rightClick="lookOrder">
		</confirm-modal>
		
		<!-- 是否处理成功弹框  撤单成功弹框-->
		<confirm-modal v-if="isSuccess" :isEnough="true" :firmTitle="firmTitle_1" :firmLeft="firmLeft_1" :firmRight="firmRight_1"
		    @leftClick="onCloseModalClick" @rightClick="submitSuccess">
		</confirm-modal>
        
		<!-- 撤单原因弹框 -->
		<common-modal :showClose="true" v-if="isRescind" @close-modal="onCloseModalClick">
			<div class="modal ">
			    <div class="title">请选择撤回原因</div>
			    <ul class="list-wrap che-dan">
					<li>
						<textarea class="textarea" :rows="8" v-model="otherReason" @blur="backHeight" placeholder="请详细描述撤单原因，便于管理员找商家谈条件，好提高成功率"/>
					</li>
					
					<li class="admin-img">
						<div class="num">上传图片（{{addImages.length }}/6）</div>
						<imageUpload v-model="addImages" :limit="6" class="add-img"/>
					</li>
			    </ul>
			    <div class="modal-submit" @click="submitRescind">提交</div>
			</div>
		</common-modal>
		
		<!-- 是否撤回订单,确认退款，已驳回状态下的撤单弹框-->
		<confirm-modal v-if="isRevoke" :firmTitle="firmTitle_2" :firmLeft="firmLeft_1" :firmRight="firmRight_1"
		    @leftClick="onCloseModalClick" @rightClick="submitRevoke">
		</confirm-modal>
		<!-- 订单进度 -->
		<progress-bar :detailList="detailList" role="sale"></progress-bar>
		<!-- 服务项目信息 -->
		<service-items :detailList="detailList" role="sale"></service-items>
		<contact-info  :detailList="detailList"></contact-info>
		<after-sale :detailList="detailList"></after-sale>
        <div class="order-detail" v-if="detailList.order_supplement">
            <div class="link-wrap">
        		<img src="@/assets/images/order-manage/ic_home_line_6.png" alt="" class="pt-img">
                <span class="link">补充信息</span>
            </div>
        	<p class="supply-content">{{detailList.order_supplement}}</p>
            <div class="img-list">
                <img v-for="(item,index) in detailList.order_supplement_img" :key="index" :src="item" alt="" @click="handleImgsClick(detailList.order_supplement_img,index)" class="img-size" />
            </div>
        </div>
		
		<!-- 1待支付 2待处理 3 处理中 4待确认 5已完成 6 已撤单 7 取消单 8 已驳回 9已退款 -->
		<!-- 处理中（未分配业务员) 已取消 无操作按钮 -->
		<div class="operat" v-if="isShowStatus">
			<!-- 待处理 -->
			<div v-if="detailList.order_status==2">
				<span class="complete only-one" @click.stop="handle">开始</span>
			</div>

			<!-- 处理中-->
			<div v-if="detailList.order_status==3">
				<span @click="rescind">撤回</span>
				<span class="complete gen-jin"  @click="handleSuccess">成功</span>
				<span class="complete gen-jin"  @click="follow">进度</span>
			</div>
				
			<!-- 待确认，已完成，已驳回，已关闭 -->
            <div v-if='detailList.order_status==4 || detailList.order_status==5 || detailList.order_status==6 || detailList.order_status==9 || detailList.order_status==11|| detailList.order_status==8 || detailList.order_status==10|| detailList.order_status==13'>
                <div v-if="detailList.order_status==4 || detailList.order_status==10">
                    <span class="complete" @click="follow">进度</span>
                </div>
                
                <div v-else>
                    <span class="complete un-click" @click="follow">进度</span>
                </div>
             </div>
		</div>

    </section>
</template>

<script>
	import ProgressBar from '@/components/ProgressBar';
	import ContactInfo from '@/components/ContactInfo';
	import ServiceItems from '@/components/ServiceItems';
	import imageUpload from '@/components/ImageUpload';
    import CommonHeader from '@/components/CommonHeader'
    import ConfirmModal from '@/components/ConfirmModal'
    import CommonModal from '@/components/CommonModal'
	import AfterSale from '@/components/AfterSale'
	import {getOrderDetail,processingOrder} from '@/api/order'
    import utils from '@/assets/jslibs/utils'
    export default {
        name: 'service-order',
        data:function(){
            return {
				isModifymoney:false,			//是否修改佣金
				imgUrl:this.$store.state.imgUrl || sessionStorage.getItem("imgUrl"),
				isShowTime:false,      //是否设置时间弹框
				isSetTime:false,        //设置截止时间成功弹框 ,撤单成功弹框
				isSuccess:false,  		//是否处理成功弹框 
				isRescind:false,       //选择撤单原因弹框
				otherReason:"",        //撤单的其它原因
				addImages:[],          //上传的图片
                firmTitle_1:"订单解决了吗？",
				firmLeft_1:"否",
				firmRight_1:"是",
				isRevoke:false,         //是否撤回订单，以及驳回状态下的是否撤单
				firmTitle_2:"是否撤回该订单",
				firmTitle:"截止时间设置成功",
				firmLeft:"返回列表",
                firmRight:"查看订单",
				order_uuid:this.$route.query.order_uuid,
				detailList:{
					server_info:{}
				},
				isOverTime:false,
				leftTime:"",
				// reasons_for_cancellation:"",   //撤单理由
				// selectFlag:0,
				// rescindList:["客户不愿意协商","无法联系客户","商家要求撤单","其它原因"],
                wrapperHeight:"",
				notSale:false,
				isShowStatus:false
            }
        },
        components: {
			imageUpload,
            ConfirmModal,
            CommonModal,
            CommonHeader,
			AfterSale,
			ServiceItems,
			ContactInfo,
			ProgressBar
        },
        
        beforeRouteLeave(to, from, next) {
            // 设置下一个路由的 meta
            to.meta.keepAlive = false; // 让 A 缓存，即不刷新
            next();
        },
		
		beforeCreate(){
			sessionStorage.removeItem("roleType");
		},
       
        created() {
            this.getOrderDetail()
        },
        
        mounted(){
            document.title = "订单详情"
            this.wrapperHeight = document.documentElement.clientHeight;
			window.addEventListener('touchmove', (event)=>{ 
			    if(this.isOverTime || this.isShowTime || this.isSetTime || this.isSuccess || this.isRescind){
			        event.preventDefault(); 
			    }
			}) 
        },
        
        methods: {
			//获取订单详情
			async getOrderDetail(){
				const { data, status } = await getOrderDetail(this.order_uuid);
				if (status !== 200) return 
				this.detailList = data;
				this.detailList.after_sale_name = utils.typeToName(this.detailList.after_sale_type)
				this.detailList.statusName = utils.statusToNameSale(this.detailList.order_status)
				this.detailList.question_url = this.detailList.question_url.split(",");
                this.order_uuid = this.detailList.uuid;
				
				if(this.detailList.order_status!=1 && this.detailList.order_status!=7){
					this.isShowStatus = true
				}
                
                // 补充信息
                if(this.detailList.order_supplement_img && this.detailList.order_supplement_img.length){
                    this.detailList.order_supplement_img.forEach((item,index)=>{
                		if(!item.includes("http") && !item.includes("https")){
                			this.detailList.order_supplement_img[index] = this.imgUrl + this.detailList.order_supplement_img[index];
                		}
                    })
                }
                
				if(this.detailList.deadline){
                    this.detailList.deadline = this.detailList.deadline.slice(0,10);
					var deadline = new Date(this.detailList.deadline).getTime();
					var today = new Date().getTime()
					var twoDay = 24*3600*1000*2
					var fourDay = 24*3600*1000*4
					if(twoDay<(deadline-today) && (deadline-today)<fourDay){
						this.isOverTime = true;
						this.leftTime = "距离订单截止时间还剩3天,请及时处理";
					}
					
					if(0<(deadline-today) && (deadline-today)<twoDay){
						this.isOverTime = true;
						this.leftTime = "距离订单截止时间还剩1天,请及时处理";
					}
					
					if(deadline < today){
						this.isOverTime = true;
						this.leftTime = "订单已超时,请及时处理";
					}
				}
			},
			
			// 开始处理
			handle(){
			    this.isShowTime = true;
			},
			
			// 撤回订单
			revoke(){
				this.isRevoke= true;
				this.firmLeft_1 = "取消";
				this.firmRight_1 = "确定";
			},
			
			// 处理成功
			handleSuccess(){
				this.isSuccess = true    //和设置时间成功共用弹框
			},
			
			// 撤回
			rescind(){
				this.isRescind = true
			},
			
			//跟进记录
			follow(){
				this.$router.push({path:'./order-speed',query:{order_uuid:this.order_uuid,follow:"sale"}})
			},

			// 设置处理的截止时间
			showDatePicker() {
			    this.isShowTime = false;
			    if (!this.datePicker) {
			        this.datePicker = this.$createDatePicker({
			            title: '设置截止时间',
			            min: new Date(2008, 7, 8),
			            max: new Date(2020, 9, 20),
			            value: new Date(),
			            onSelect: this.selectHandle,
			            onCancel: this.cancelHandle
			        })
			    }
			    
			    this.datePicker.show()
			},
			
			//确定选择时间，并开始处理
			selectHandle(date, selectedVal, selectedText) {
			    this.deadline = selectedVal[0]+"-"+selectedVal[1]+"-"+selectedVal[2];
			    this.processingOrder("1");     //处理订单
			},
			
			//无需设置截止时间，直接开始处理
			noSetHandle(){
			    this.isShowTime = false;
				this.firmTitle = "订单开始处理中" 	//直接处理成功提示语不一样
			    this.processingOrder("1");
			},
			
			//确认完成订单
			submitSuccess(){
				this.isSuccess = false
				this.processingOrder("2");          //确认处理成功订单
			},
			
			// 确认撤回订单，退款，驳回下的撤单
			submitRevoke(){
				this.isRevoke = false;
				this.processingOrder("3");
			},
			
			// 确定撤销订单
			submitRescind(){
                if(!this.otherReason){
                    window.toast("请输入撤回原因","txt");
                    return
                }
                
                if(this.otherReason.length>100){
                    window.toast("撤回原因不得超过100字符","txt");
                    return
                }
				this.isRescind = false
				this.processingOrder("4");
			},
			
			// 操作订单
			async processingOrder(type){
			    let obj={type:type,deadline:this.deadline,reasons_for_cancellation:this.otherReason,img:this.addImages};
			    const { data, status } = await processingOrder(this.order_uuid,obj);
			    if (status !== 200) return  
				if(type=="1"){								//处理订单
					this.isSetTime = true
				}else if(type=="2"){
					this.getOrderDetail(this.order_uuid)		//确认完成订单之后，刷新订单
				}else if(type=="4"){							//撤单成功
					this.firmTitle = "撤回成功"
					this.isSetTime = true
				}
			},
			
			// 返回列表,并重新获取状态,当前页面下直接关闭弹框
			goBackList(){
			    this.isSetTime = false;
				this.$router.push({path:'./index-sale'})
			},
			
			// 查看订单
			lookOrder(){
				this.isSetTime = false;
			    this.getOrderDetail(this.order_uuid)
			},

            // 关闭弹框
            onCloseModalClick(){
				this.isShowTime= false;
				this.isSuccess = false;
				this.isRescind = false;
				this.isOverTime =false;
				this.isRevoke = false;
            },
			
			handleImgsClick(item,index) {
				this.initialIndex = index
				const params = {
					$props: {
						imgs: item,
						initialIndex: 'initialIndex', // 响应式数据的key名
						loop: false
					},
					$events: {
						change: (i) => {
							// 必须更新 initialIndex
							this.initialIndex = i
						}
					}
				}
				this.$createImagePreview({ ...params }).show()
			},
            
            backHeight(){
                setTimeout(() => {
                    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                }, 100);
            }
        }
    }
</script>

<style>

	
</style>

<style lang='less' scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
    section{font-family:PingFangSC-Regular;font-weight:400;background:#F5F5F5;-webkit-overflow-scrolling: touch;padding:10px 10px 57px 10px;}
    .no-p{padding-bottom: 10px}
	.list{overflow-y: scroll; width: 100%;height: 100%;};
	.banner{width: 375px;height: 100px;padding:27px 0 0 40px;font-size: 18px; font-family: PingFangSC-Medium;font-weight: 500;color: rgba(255,255,255,1);background: url(../../assets/images/home/pic_order_banner.png) no-repeat center center;background-size: cover}
    .dead-time{font-size:13px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(255,255,255,1)}
    .service-left{color:rgba(51,51,51,1);text-align: justify;display: inline-block;vertical-align: top;.f-s(15);font-family:PingFangSC-Medium;font-weight:500;}
	.have-between{justify-content: space-between;}
	.pt-img{height: 20px;margin-right: 8px;display: inline-block;vertical-align:middle}
	.order-left{color:rgba(51,51,51,1);font-size:13px;}
	.add-font{font-size: 14px;font-weight: 600;}
	.server-wrap{display: flex;margin: 10px;padding: 10px;background: #fff;}
	.assess-icon{width: 58px;height: 60px;margin-right: 10px}
	.server-content{flex:1;display: flex;align-items: center;justify-content: space-between;}
	.server-name{font-size:15px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1)}
	.commission{padding-top: 8px;font-size:13px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(51,51,51,1);}
	.follow{height: 19px;font-size:12px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(245,171,21,1);}
	.money{padding-top: 8px;font-size:14px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(51,51,51,1);}
	
	.order-detail{margin-bottom: 0.266667rem;background: #fff;padding-bottom: 0.266667rem;}
    .link-wrap{font-size: 0;height: 1.38666667rem;margin: 0 10px;line-height: 1.38666667rem;border-bottom: 0.026667rem solid #EEEEEE;}
	.link{display: inline-block;vertical-align: middle;color:rgba(20,20,20,1);font-size: 0.4rem;}
	.show-link{width: 335px;padding: 10px;margin: 0 auto;color:rgba(74,74,74,1);font-size: 14px;box-sizing: content-box}
    .customer-info{padding: 10px 10px 2px 10px;display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;align-items: center;}
    .info-style{color:rgba(74,74,74,1);font-size: 14px}
    .p-b{padding-bottom:8px}
    .f-s{color: #4a4a4a;font-size: 0.373333rem;}
    .un-connection{display: inline-block;color:rgba(65,132,244,1);font-size: 13;padding:5px 17px;background:rgba(239,247,255,1);border-radius:4px;margin: 11px 0 9px 10px}
    .describe{color:rgba(74,74,74,1);font-size: 14px;padding: 0 10px 8px 10px;}
	.supply-content{padding: 10px 15px 15px 10px;font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(102,102,102,1);}
    .img-list{display: -webkit-box;display: -ms-flexbox;display: flex;flex-wrap: wrap;padding:0 10px}
    .img-size{width: 95px;height:95px;margin-right: 16px;margin-bottom: 7.5px};
	.img-list .img-size:nth-child(3n){margin-right: 0}
    .agree-img{width: 22px;height: 22px;margin-right: 8px;display: inline-block;vertical-align:middle}
    .agree{background: url(../../assets/images/home/pic_right2_pitchon.png) center center no-repeat;background-size: cover}
    .un-agree{background: url(../../assets/images/home/pic_right2_pitchoff.png) center center no-repeat;background-size: cover}
    .agree-text{padding: 10px 22px 10px 15px}
    .agree-text p{font-size:14px;color:rgba(20,20,20,1);line-height:20px;margin-bottom: 10px}
    .operat{position: fixed;bottom: 0;left: 0;width: 375px;height: 50px;background: #fff}
	.operat div{padding-right: 10px;text-align: right;}
	.operat span{display: inline-block;width: 65px;height: 30px;margin-top: 10px;border-radius:2px;border: 1px solid rgba(153,153,153,1);text-align: center;line-height: 30px;color:rgba(153,153,153,1);font-size: 13px;}
	.reject{margin-left: 120px}
	.notes{margin-left: 20px}
	.operat .complete{margin-left: 10px;background:rgba(65,132,244,1);color:rgba(255,255,255,1);border: none}
	.only-one{float: right;margin-right: 20px;}
	.operat .gen-jin{border:1px solid rgba(65,132,244,1);color:rgba(65,132,244,1);background: #fff}
    /* 弹框 */
    .modal{width: 320px;/* height: 327px; */background: #fff;margin: 0 auto;padding-bottom: 35px;}
    .title{padding: 12px 21px;/* background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat 93% center;background-size: 12px; */font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;border-bottom: 1px solid #E9E9E9}
    .list-wrap{padding: 18px 21px 6px 21px;}
    .list-wrap li{margin-bottom: 10px}
    .select-mark{display: inline-block;width:17px;height:17px;border-radius: 50%;margin-right: 7px;vertical-align: top;margin-top: 4px}
    .on{background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size:cover;}
	.modal-text{display: inline-block;width: 243px;font-size:15px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);vertical-align: top;}
    .modal-submit{width:278px;height:40px;margin: 0 auto;line-height:40px;border-radius:5px;font-size:18px;font-family:PingFangSC-Regular;font-weight:400;background:rgba(65,132,244,1);text-align: center;color:rgba(255,255,255,1);}

	 /* 是否设置截止时间弹框 */
	.time-common{.w(277.5);.h(40);.l-h(40);margin:0 auto;border-radius:5px;text-align: center;.f-s(18);font-family:PingFangSC-Regular;font-weight:400;}
	.set-time{background:rgba(65,132,244,1);color:rgba(255,255,255,1);margin: 19px auto 20px auto}
	.no-time{background:rgba(255,255,255,1);border:1px solid rgba(207,207,207,1);color:rgba(153,153,153,1);}
	
	/* 撤单理由弹框 */
	.textarea{width: 278px;height: 100px;padding: 10px;background:rgba(245,245,245,1);border-radius:2px;border:1px solid rgba(207,207,207,1);resize: none;outline: none;font-size:13px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(153,153,153,1);}
	.done{background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size:cover;}
	.undone{background: url(../../assets/images/home/pic_right2_pitchoff.png) center center no-repeat;background-size: cover}
    .num{font-size:14px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);margin-bottom: 12px}
	.dankal-image-upload /deep/ .add-box{padding-left: 0 !important}
	.dankal-image-upload /deep/ .add-box /deep/ .add{width: 80px;height: 80px}
	.dankal-image-upload /deep/ p /deep/ .upload_img{width: 80px;height: 80px}
	
	.time-wrap{width: 270px;background: #fff;margin: 0 auto;text-align: center}
	.tips{font-size: 18px;font-weight: 500;color: rgba(51,51,51,1);text-align: center;padding: 24px 0 8px 0;}
	.left-time{font-size: 14px;font-family: PingFangSC-Regular;font-weight: 400;color: rgba(51,51,51,1);padding-bottom: 17px;border-bottom: 1px solid #DDDDDD;}
	.know{font-size: 18px;font-weight: 400;color: rgba(65,132,244,1);padding: 12.5px 0;}
    .operat .un-click{background:#f5f5f5;color:#999;border-color:#f5f5f5;}
</style>
